/**
 * Executa o `import()` de chunks lazy com tentativas automáticas.
 *
 * POR QUE EXISTE: o erro "Failed to fetch dynamically imported module" acontece
 * quando o navegador não consegue baixar o chunk de uma página lazy-loaded —
 * por falha TRANSITÓRIA de rede/servidor (instabilidade, reinício do host, etc.)
 * ou porque o hash do arquivo mudou após um deploy (aba aberta antes do deploy
 * tenta o hash antigo, que não existe mais no servidor).
 *
 * Este helper tenta de novo algumas vezes com um pequeno intervalo: resolve
 * falhas transitórias SEM precisar recarregar a página (que é a maior parte dos
 * casos "intermitentes"). Se mesmo assim falhar, o erro propaga para o
 * ErrorBoundary, que recarrega a página com o index.html novo — cobrindo o caso
 * do deploy (hash antigo não existe mais, e só um reload com cache-busting
 * resolve).
 *
 * Uso: `lazy(() => lazyRetry(() => import("../pages/exemplo/page")))`
 */
export function lazyRetry<T>(
  importer: () => Promise<T>,
  retries = 2,
  delayMs = 350
): Promise<T> {
  return importer().catch((err: unknown) => {
    if (retries <= 0) throw err;
    return new Promise<T>((resolve) => setTimeout(resolve, delayMs)).then(() =>
      lazyRetry(importer, retries - 1, delayMs)
    );
  });
}
